import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const outcomes = [{
  layer: 'Master-class Intro',
  serves: 'Speaker Vanity + KEE Advocacy',
  impact: 'Immediate credibility and engagement'
}, {
  layer: 'The Menu',
  serves: 'HCP Enablement',
  impact: 'Personalized learning paths'
}, {
  layer: 'Scientific Core',
  serves: 'HCP Enablement + KEE Advocacy',
  impact: 'Unbiased, credible education'
}, {
  layer: 'X-Ray Overlay',
  serves: 'All Three Objectives',
  impact: 'Enhanced value without disruption'
}];
export function TheJourney() {
  return <section className="py-24 bg-white" data-id="element-121">
      <div className="max-w-6xl mx-auto px-6" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-123">
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-124">
            The Journey
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-125">
            Each layer serves the strategic objectives — nothing is decorative
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-126">
          {outcomes.map((outcome, index) => <motion.div key={outcome.layer} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-red-300 transition-colors" data-id="element-127">
              <div className="flex items-start gap-4" data-id="element-128">
                <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0" data-id="element-129">
                  <CheckCircle2 className="w-6 h-6 text-white" data-id="element-130" />
                </div>
                <div className="flex-1" data-id="element-131">
                  <div className="flex items-center gap-3 mb-2 flex-wrap" data-id="element-132">
                    <h3 className="text-xl font-bold text-slate-900" data-id="element-133">
                      {outcome.layer}
                    </h3>
                    <ArrowRight className="w-5 h-5 text-slate-400" data-id="element-134" />
                    <span className="text-sm font-semibold text-red-600" data-id="element-135">
                      {outcome.serves}
                    </span>
                  </div>
                  <p className="text-slate-600" data-id="element-136">{outcome.impact}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}